import * as React from "react";

const GridView: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 17.5" fill="currentColor">
            <path
                d="M11.562 0a.937.937 0 0 0-.937.937v6.25c0 .518.42.938.937.938h7.5c.518 0 .938-.42.938-.938V.937A.937.937 0 0 0 19.062 0h-7.5ZM8.437 0h-7.5A.937.937 0 0 0 0 .937v6.25c0 .518.42.938.937.938h7.5c.518 0 .938-.42.938-.938V.937A.937.937 0 0 0 8.437 0ZM0 10.312v6.25c0 .518.42.938.937.938h7.5c.518 0 .938-.42.938-.938v-6.25a.937.937 0 0 0-.938-.937h-7.5a.937.937 0 0 0-.937.937ZM11.562 17.5h7.5c.518 0 .938-.42.938-.938v-6.25a.937.937 0 0 0-.938-.937h-7.5a.937.937 0 0 0-.937.937v6.25c0 .518.42.938.937.938Z"
            />
        </svg>
    );
};

export default React.memo(GridView);
